'use strict';
class FilterAllButton {
    clearFilter(filter) {
        filter.splice(0, filter.length);
    }
}

angular
    .module('TR')
    .directive('filterAllButton', (): ng.IDirective => {
        return {
            controller: FilterAllButton,
            controllerAs: 'fab',
            bindToController: {
                model: '='
            },
            replace: true,
            template: `
                <label
                    class="checkbox-btn full-width"
                    ng-click="fab.clearFilter(fab.model)"
                    ng-class="{'checked': !fab.model.length}">
                    <div class="icon"></div>
                    <div class="label-content"><span>{{'FILTERALLBUTTON'|resource}}</span></div>
                </label>`
        };
    });
